import { createApi } from "@reduxjs/toolkit/query/react";

import { API_VALIDATOR_KEYS } from "@/constants/customer-portal/general.constant";
import { XeroInvoiceItem } from "@/interfaces/invoicing.interface";
import { BaseWithAuth, getCustomerId } from "@/utils/helpers";

export const C_InvoiceApi = createApi({
  reducerPath: "C_InvoiceApi",
  baseQuery: BaseWithAuth(),
  tagTypes: [API_VALIDATOR_KEYS.INVOICES],
  endpoints: (builder) => ({
    getCustomerInvoice: builder.query<
      GeneralResponse<XeroInvoiceItem[]>,
      { filter?: string; status: string }
    >({
      query: ({ filter, status }) =>
        `customer/${getCustomerId()}/invoices${status ? `?status=${status}` : ""}${filter ? filter : ""}`,
      providesTags: [API_VALIDATOR_KEYS.INVOICES],
    }),
  }),
});

export const { useGetCustomerInvoiceQuery } = C_InvoiceApi;
